import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../App";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { CheckCircle, Loader2 } from "lucide-react";

var API_URL = process.env.REACT_APP_BACKEND_URL;

export default function PaymentSuccess() {
  var navigate = useNavigate();
  var [searchParams] = useSearchParams();
  var { login } = useAuth();
  var { t } = useTranslation();
  var [loading, setLoading] = useState(true);
  var [verified, setVerified] = useState(false);

  useEffect(function() {
    var sessionId = searchParams.get("session_id");
    if (sessionId) {
      verifyPayment(sessionId);
    } else {
      // Check for pending registration
      var pendingReg = localStorage.getItem("pending_registration");
      if (pendingReg) {
        var userData = JSON.parse(pendingReg);
        login(userData, userData.token);
        localStorage.removeItem("pending_registration");
        setVerified(true);
        setLoading(false);
      } else {
        navigate("/");
      }
    }
  }, [searchParams, navigate, login]);

  async function verifyPayment(sessionId) {
    try {
      var response = await fetch(API_URL + "/api/payments/stripe/status/" + sessionId);
      var data = await response.json();
      
      if (data.payment_status === "paid") {
        // Get pending registration data
        var pendingReg = localStorage.getItem("pending_registration");
        if (pendingReg) {
          var userData = JSON.parse(pendingReg);
          login(userData, userData.token);
          localStorage.removeItem("pending_registration");
        }
        setVerified(true);
      }
    } catch (err) {
      console.error("Error verifying payment:", err);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <Card className="max-w-md w-full border-2" data-testid="payment-success-card">
        <CardHeader className="text-center">
          {loading ? (
            <>
              <Loader2 className="w-16 h-16 mx-auto text-primary animate-spin mb-4" />
              <CardTitle className="text-2xl">{t("payment.verifying")}</CardTitle>
              <CardDescription>{t("payment.pleaseWait")}</CardDescription>
            </>
          ) : verified ? (
            <>
              <CheckCircle className="w-16 h-16 mx-auto text-green-500 mb-4" />
              <CardTitle className="text-2xl">{t("payment.success")}</CardTitle>
              <CardDescription>{t("payment.welcomeMessage")}</CardDescription>
            </>
          ) : (
            <>
              <CardTitle className="text-2xl">{t("payment.error")}</CardTitle>
              <CardDescription>{t("payment.verificationFailed")}</CardDescription>
            </>
          )}
        </CardHeader>
        <CardContent>
          {!loading && (
            <Button onClick={function() { navigate("/dashboard"); }} className="w-full" data-testid="go-to-dashboard-btn">
              {t("payment.goToDashboard")}
            </Button>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
